export default __webpack_public_path__ + "f4905658904ab96b9595195d43a533c3.png";